import React from 'react';
import { Box, Typography } from '@mui/material';
import './InsightsCard.css';

const InsightsCard = ({ title, value, showRating = false, rating, actionText, onActionClick }) => {
  return (
    <Box className="insights-card">
      <Box className="insights-card-header">
        <Typography variant="body1" className="insights-card-title">
          {title}
        </Typography>
        {actionText && (
          <Typography variant="body2" className="insights-card-action" onClick={onActionClick}>
            {actionText}
          </Typography>
        )}
      </Box>
      <Box className="insights-card-content">
        {showRating ? (
          <Box className="insights-card-rating">
            <span>⭐</span>
            <Typography component="span" className="insights-card-value">
              {rating}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" className="insights-card-value">
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default InsightsCard;
